import { Add } from "iconsax-reactjs";
import Button from "../../commons/Button";

type Props = {
  onCreate: () => void;
};

export default function ChallengeEmptyState({ onCreate }: Props) {
  return (
    <section
      className="flex h-[468px] w-full flex-col rounded-2xl border bg-white px-3 pt-3 pb-8 card-shadow"
      dir="rtl"
    >
      <header className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center">
          <span className="ml-2 h-6 w-[3px] rounded-full bg-primaryVar" />
          <h1 className="text-lg font-semibold text-gray-800">
            لیست زنجیره‌های هفتگی
          </h1>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="primary"
            style="outline"
            size="md"
            text="زنجیره جدید"
            loading={false}
            disabled={false}
            onClick={onCreate}
            icon={Add}
          />
        </div>
      </header>

      <div className="flex flex-1 flex-col items-center justify-center pb-2 text-center">
        <h2 className="text-sm font-semibold text-gray-700">
          هنوز زنجیره‌ای ایجاد نشده است
        </h2>
        <p className="mt-2 max-w-md text-xs leading-5 text-gray-500">
          برای شروع، روی دکمه «زنجیره جدید» کلیک کنید و اولین زنجیره چالش
          طلایی را برای پایه و رشته موردنظر ایجاد کنید.
        </p>
        <Button
          variant="primary"
          style="solid"
          size="md"
          text="زنجیره جدید"
          loading={false}
          disabled={false}
          onClick={onCreate}
          icon={Add}
          customClassName="mt-8 h-10 rounded px-3 text-xs"
        />
      </div>
    </section>
  );
}
